import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { hideHeaderAndFooter } from "../../../_helpers/hide-header-and-footer";

/**
 * For manipulating components on staging and development only.
 * will be deprecated once there will be a Storybook
 */
@Component({
  selector: "white-board",
  templateUrl: "./white-board.component.html",
  styleUrls: ["./white-board.component.scss"],
})
export class WhiteBoardComponent implements OnInit, OnDestroy {
  constructor(
    private eventsService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {}

  public ngOnInit(): void {
    this.removeUnwantedPageElements();
  }

  public ngOnDestroy(): void {}

  private removeUnwantedPageElements() {
    hideHeaderAndFooter();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/white-board/white-board.component.ts